/*eslint-env jquery*/
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { appUsersService } from '../../_services/AppUsers.service'
import Modal from 'react-responsive-modal'
import memberStatuses from '../../_constants/memberStatuses'
import PicUploaderLinerAdmin from '../Shared/PicUploaderLinerAdmin'
import DatePicker from '../Shared/DatePicker'
import NumberFormat from 'react-number-format'
import ClassSelect from '../Shared/ClassSelect'
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import { StatusSelect } from '../Shared/StatusSelect'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'

import { config } from '../../config'
const base_url = config.apiBaseUrl
export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

const requestData = (pageSize, page, sorted, filtered, dto) => {
  // console.log(dto)
  return new Promise(async (resolve, reject) => {
    // var dto = {};
    dto['pageSize'] = pageSize
    dto['page'] = page + 1
    dto['sorted'] = sorted
    // console.log(JSON.stringify(dto));

    var result = []
    await appUsersService
      .getAll(JSON.stringify(dto))
      .then(res => {
        // console.log(res)
        result = res
      })
      .catch(() => {
        setTimeout(
          () => requestData(pageSize, page, sorted, filtered, dto),
          2000
        )
      })

    setTimeout(() => resolve(result), 500)
  })
}

class AppUsers extends Component {
  constructor(props, context) {
    super(props, context)
    var pageSize = parseInt(localStorage.getItem('pageSize'), 0)

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      pageSize: pageSize ? pageSize : 10,
      selected: {},
      selectAll: 0,
      dto: {},
      model: {}
    }
  }

  handleModalShow = () => {
    this.setState({ modalHeading: 'جستجو', searchModal: true })
  }

  handleSearchModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ searchModal: false })
  }

  handleModalEdit = e => {
    let _model = this.state.data[e.target.dataset.index]
    // console.log(_model);

    this.setState({
      modal: true,
      model: _model,
      modalHeading: 'ویرایش کاربر "' + _model.userName + '"'
    })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  // getData() {

  //   var dto = {
  //     "page": 1,
  //     "pageSize": 5
  //   }
  //   appUsersService.getAll(JSON.stringify(dto))
  //     .then((res) => {
  //       console.log(res.data)
  //       var data = res.data;
  //       var pageSize = data.result.length > 10 ? 10 : data.result.length;
  //       this.setState({ initialItems: data, pageSize: pageSize, data: data, loading: false, isSubmitting: false, modal: false });
  //     })
  //     .catch((error) => {
  //       this.handleError(error)
  //     });
  // };

  handleError(error) {
    this.setState({ loading: false })
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    appUsersService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف کاربر', 'کاربر با موفقیت حذف شد')

        this.table.fireFetchData()
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  handleSearch = values => {
    this.setState({ loading: true })
    // console.log(values);

    const { dto } = this.state
    if (values) {
      Object.entries(values).reduce((acc, [key, value]) => {
        dto[key] = value ? value : undefined
      })
      this.setState({ dto: dto }, () => {
        this.table.fireFetchData()
      })
    }
  }

  toggleRow(id) {
    const newSelected = Object.assign({}, this.state.selected)
    newSelected[id] = !this.state.selected[id]
    this.setState({
      selected: newSelected,
      selectAll: 2
    })
  }

  toggleSelectAll() {
    let newSelected = {}

    if (this.state.selectAll === 0) {
      this.state.data.forEach(x => {
        newSelected[x.id] = true
      })
    }
    // console.log(JSON.stringify(newSelected));

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0
    })
  }

  fetchData = (state, instance) => {
    // console.log(instance);

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true })
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered,
      this.state.dto
    )
      .then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        // console.log(res.data.result.length );
        // console.log(state.pageSize );
        if (res.data.result) {
          var pageSize =
            res.data.result.length > state.pageSize
              ? state.pageSize
              : res.data.result.length
          // console.log(pageSize );
          this.setState({
            data: res.data.result,
            pages: Math.ceil(res.data.totalRecord / state.pageSize),
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: pageSize
          })
        }
      })
      .catch(() => {
        this.table.fireFetchData()
      })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      // name: Yup.string().trim().required('نام شرکت کننده'),
    })
    const { model, loading, data, pages, pageSize, dto } = this.state
    return (
      <div>
        <div style={{ display: 'inline' }}>
          <a
            href="/admin/user/new"
            className="btn btn-primary react-table-add-btn"
            style={{ float: 'left' }}>
            <i className="mdi mdi-plus" />
            افزودن کاربر جدید
          </a>
          <a
            onClick={this.handleModalShow}
            className="btn btn-primary react-table-add-btn"
            style={{ alignSelf: 'flex-start' }}>
            <i className="mdi mdi-magnify" />&nbsp;جستجو
          </a>
        </div>

        <br />

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable
            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={instance => {
              this.table = instance
            }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort })
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSize', pageSize)
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}
            defaultPageSize={pageSize}
            previousText="صفحه قبل"
            nextText="صفحه بعد"
            loadingText="در حال بارگذاری ..."
            noDataText="نتیجه ای یافت نشد"
            pageText="صفحه"
            ofText="از"
            rowsText="تعداد نمایش"
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected)
              const selected = rowInfo
                ? newSelected[rowInfo.original.id]
                : false
              return {
                style: {
                  backgroundColor: selected && '#5079F7',
                  color: selected && 'white'
                }
              }
            }}
            // defaultFilterMethod={(filter, row) =>
            //   String(row[filter.id]) === filter.value}
            columns={[
              {
                Header: 'ردیف',
                id: 'row',
                maxWidth: 50,
                filterable: false,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                Cell: row => {
                  return row.index + 1
                }
              },
              {
                Header: 'نوع کاربر',
                accessor: 'userType',
                id: 'userType',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'visible',
                  justifyContent: 'center'
                },

                filterMethod: (filter, row) => {
                  if (filter.value === null || filter.value === undefined) {
                    return true
                  }
                  if (row[filter.id] === filter.value.value) {
                    return true
                  }
                  // console.log(filter);
                  //return row[filter.id] === filter.value;
                },
                Cell: row => (
                  <div>
                    {row.original.userType === 0
                      ? 'مدیر سیستم'
                      : row.original.userType === 1
                      ? 'اتحادیه'
                      : row.original.userType === 2
                      ? 'اپراتور'
                      : ''}
                  </div>
                ),
                Filter: ({ onChange }) => (
                  <Select
                    isClearable
                    placeholder=""
                    options={[
                      { value: 0, label: 'مدیر سیستم' },
                      { value: 1, label: 'اتحادیه' },
                      { value: 2, label: 'اپراتور' }
                    ]}
                    onChange={event => onChange(event)}
                  />
                )
              },
              {
                Header: 'نام و نام خانوادگی',
                id: 'fullName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                accessor: el => el.firstName + el.lastName,
                filterMethod: (filter, row) => {
                  const escapedStr = filter.value.toLowerCase()
                  const termsArr = escapedStr.split(' ')
                  const finalRegexStr = termsArr.reduce(
                    (acc, curr, idx) => acc + '(?=.*' + curr + ')',
                    ''
                  )
                  const regex = new RegExp(finalRegexStr)
                  return regex.test(row[filter.id])
                },
                Cell: props => (
                  <span>
                    {props.original.firstName} {props.original.lastName}
                  </span>
                ),
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'نام کاربری',
                accessor: 'userName',
                id: 'userName',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['userName'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'شماره موبایل',
                accessor: 'mobile',
                id: 'mobile',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['mobile'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                )
              },
              {
                Header: 'اتحادیه',
                accessor: 'union',
                id: 'union',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                className: 'numberFa',
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ['union'] }),
                filterAll: true,
                Filter: ({ onChange }) => (
                  <Input
                    placeholder=""
                    allowClear
                    onChange={event => onChange(event.target.value)}
                  />
                ),
                Cell: props => (
                  <span>
                    {props.original.union ? props.original.union.name : ''}
                  </span>
                )
              },
              {
                Header: 'ویرایش',
                accessor: 'id',
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                },
                sortable: false,
                // filterable: false,
                // Filter: ({ filter, onChange }) =>
                //   <Link to="/admin/User/new" className="btn btn-primary react-table-add-btn">
                //     <i className="mdi mdi-plus"></i>
                //     افزودن کاربر جدید
                //   </Link>,
                Cell: row => (
                  <div>
                    <Link
                      to={'/admin/user/' + row.original.id + '/edit'}
                      params={{ id: row.original.id }}
                      className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                      rel="tooltip"
                      data-original-title="ویرایش">
                      <i className="mdi mdi-pencil" />
                    </Link>
                    <a
                      onClick={this.handleDelete}
                      data-index={row.index}
                      className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                      data-original-title="حذف"
                      rel="tooltip">
                      <i data-index={row.index} className="mdi mdi-delete" />
                    </a>
                  </div>
                )
              }
            ]}
            // key={this.state.pageSize}
            // defaultPageSize={this.state.pageSize}
            className="-striped -highlight"
          />
        </div>
        <Modal
          open={this.state.searchModal}
          onClose={this.handleSearchModalHide}
          center
          classNames={{
            overlay: 'customOverlay',
            modal: 'customModal lg',
            closeButton: 'customModalCloseButton'
          }}>
          <Formik
            initialValues={dto}
            onSubmit={(values, { setSubmitting }) => {
              // console.log(values);
              this.handleSearch(values)
              setSubmitting(false)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit
              } = props
              return (
                <div className="row" style={{ position: 'relative' }}>
                  <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-inline">
                          {/* <div className="col-md-2">
                                                        <label>تقویم کلاس</label>
                                                    </div>
                                                    <div className="col-md-10 rtl">
                                                        <ClassSelect
                                                            required
                                                            defaultValue={values.classId}
                                                            onChange={(val) => {
                                                                setFieldValue('classId', val);
                                                            }}
                                                        />
                                                        <ErrorMessage component={ErrorPopUp} name="classId" />
                                                    </div>

                                                    <div className="clearfix"></div> */}

                          <div className="col-md-2">
                            <label>اتحادیه</label>
                          </div>
                          <div className="col-md-10 rtl">
                            <UnionSelectForAdmin
                              required
                              defaultValue={values.unionId}
                              onChange={val => {
                                setFieldValue('unionId', val)
                              }}
                              style={{
                                height: 40,
                                background: '#fff',
                                border: 'thin solid #b4b4b4',
                                borderRadius: 7
                              }}
                            />
                            <ErrorMessage
                              component={ErrorPopUp}
                              name="unionId"
                            />
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>نام</label>
                          </div>
                          <div className="col-md-4 ">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('firstName', e.target.value)
                              }}
                              value={values.firstName}
                              name="firstName"
                            />
                            {getIn(errors, 'firstName') &&
                            getIn(touched, 'firstName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.firstName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="col-md-2">
                            <label>نام خانوادگی</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('lastName', e.target.value)
                              }}
                              value={values.lastName}
                              name="lastName"
                            />
                            {getIn(errors, 'lastName') &&
                            getIn(touched, 'lastName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.lastName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-2">
                            <label>نام کاربری</label>
                          </div>
                          <div className="col-md-4">
                            <Field
                              component={Input}
                              allowClear
                              onChange={e => {
                                setFieldValue('userName', e.target.value)
                              }}
                              value={values.userName}
                              name="userName"
                            />
                            {getIn(errors, 'userName') &&
                            getIn(touched, 'userName') ? (
                              <div className={'required_validator visible'}>
                                <div className="validator_container">
                                  <span>{errors.userName}</span>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>

                          <div className="clearfix" />

                          <div className="col-md-12">
                            <button
                              type="submit"
                              className={'icon button submit-btn pull-left'}
                              disabled={isSubmitting}>
                              {loading && (
                                <i className="mdi mdi-spin mdi-loading" />
                              )}
                              &nbsp; جستجو &nbsp;
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              )
            }}
          </Formik>
        </Modal>
        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={
            'آیا از حذف کاربر  [' + this.state.model.userName + '] مطمئن هستید؟'
          }
        />

        {this.state.loading ? <Loading /> : ''}
      </div>
    )
  }
}

export default AppUsers
